import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

// Approve/reject buttons for a pending refund request, otherwise its final status
const RefundStatusActions = ({ request, changeStatus }) => {
  switch (request?.status?.toString()) {
    case "pending":
      return (
        <div className="all-refund-status-button-container">
          <CheckIcon
            className="all-refund-status-button"
            fontSize="small"
            style={{ backgroundColor: "#5CA127" }}
            onClick={() => changeStatus("approve", request)}
          />
          <CloseIcon
            className="all-refund-status-button"
            fontSize="small"
            style={{ backgroundColor: "#D81C1C" }}
            onClick={() => changeStatus("reject", request)}
          />
        </div>
      );
    case "approved":
      return <label style={{ color: "#5CA127" }}>Approved</label>;
    case "rejected":
      return <label style={{ color: "#CB1212" }}>Rejected</label>;
    default:
      return null;
  }
};

export default RefundStatusActions;
